import {AudioPlayer} from "@/components/ui/audio-player.tsx";
import {useGetStreamsFileQuery} from "@/store/streams-files.ts";
import {Button} from "@/components/ui/button.tsx";
import {PencilIcon, TrashIcon} from "@heroicons/react/24/outline";
import {UploadAudioFile} from "@/components/ui/UploadAudioFile.tsx";
import {useState} from "react";


type AudioPlayerFromIdProps = {
    id?: number|null,
    onChange?: (id: number|null) => void,
    onDelete?: () => void,
}

export function AudioPlayerFromId({id, onChange, onDelete}: AudioPlayerFromIdProps) {

    const {data: streamFile} = useGetStreamsFileQuery(id as number, {
        skip: !id,
    });

    const [isEdit, setIsEdit] = useState(!id);

    const src = streamFile?.audio_file;

    const hasFile = id && streamFile;

    return (
        <div className="relative overflow-visible flex flex-col gap-2">
            {hasFile && (
                <>
                    <AudioPlayer src={src} title={streamFile.name}/>
                    <div className="absolute top-1 end-1">
                        {onChange && (
                            <Button
                                onClick={()  => setIsEdit(!isEdit)}
                                className="cursor-pointer" variant="ghost" size="icon-xs">
                                <PencilIcon className="h-4 w-4 text-gray-500" />
                            </Button>
                        )}
                        {onDelete && (
                            <Button onClick={onDelete} className="cursor-pointer" variant="ghost" size="icon-xs"
                            >
                                <TrashIcon className="h-4 w-4 text-gray-500" />
                            </Button>
                        )}

                    </div>
                </>
            )}

            {(!hasFile || isEdit) && (
                <UploadAudioFile
                    title={hasFile ? undefined : 'עדיין לא נבחר קובץ'}
                    initialMode={streamFile?.source === 'TTS' ? 'tts' : 'upload'}
                    onChange={(id) => {
                        setIsEdit(false);
                        onChange?.(id);
                    }}
                />
            )}
        </div>
    )
}
